/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type KeywordFilterConfigColumn = (typeof KeywordFilterConfigColumn)[keyof typeof KeywordFilterConfigColumn];

export const KeywordFilterConfigColumn = {
  keyword: 'keyword',
} as const;
